import { registerLocaleData } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Device } from '@capacitor/device';
import { TranslateService } from '@ngx-translate/core';
import { setDefaultOptions } from 'date-fns';
import { de, enUS, es, fr } from 'date-fns/locale';
import { Observable, from } from 'rxjs';
import { environment } from '../environments/environment';
import * as Sentry from '@sentry/angular';

export const HANDLED_LANGUAGES = ['fr', 'en', 'de', 'es'];
export const DEFAULT_LOCALE = 'en';

@Injectable({
    providedIn: 'root',
})
export class AppInitService {
    private translateService = inject(TranslateService);


    public init(): Observable<void> {
        return from(
            Device.getLanguageTag().then(res => {
                const langage = res?.value.split('-')[0];

                const appLocale = HANDLED_LANGUAGES.includes(langage) ? langage : DEFAULT_LOCALE;
                console.log(appLocale);

                Sentry.setTag('language', appLocale);
                Sentry.setTag('module', environment.module);

                registerLocaleData(appLocale);
                this.translateService.setDefaultLang(appLocale);

                this.translateService.use(appLocale);
                this.setDefaultDateLanguage(appLocale);
                console.log('init');
            }),
        );
    }

    public setDefaultDateLanguage(language: string) {
        switch (language) {
            case 'fr':
                setDefaultOptions({ locale: fr, weekStartsOn: 1 });
                break;
            case 'es':
                setDefaultOptions({ locale: es, weekStartsOn: 1 });
                break;
            case 'de':
                setDefaultOptions({ locale: de, weekStartsOn: 1 });
                break;
            case 'en':
            default:
                setDefaultOptions({ locale: enUS, weekStartsOn: 1 });
                break;
        }
    }
}
